<template>
  <v-card flat v-if="days.length>0">
    disponnible
    <v-chip class="mr-1 mt-1" label v-for="item in days" :key="item">{{list[item]}}</v-chip>
  </v-card>
</template>

<script>
export default {
  props: ["days"],
  data() {
    return {
      list: [
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
        "Dimanche"
      ]
    };
  }
};
</script>

<style>
</style>